<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="dcdcdf24a954e-d1e32"><span id="pagei">
<p class="copyright-statement-last">This ebook is copyright material and must not be copied, reproduced, transferred, distributed, leased, licensed or publicly performed or used in any way except as specifically permitted in writing by the publishers, as allowed under the terms and conditions under which it was purchased or as strictly permitted by applicable copyright law. Any unauthorised distribution or use of this text may be a direct infringement of the author’s and publisher’s rights and those responsible may be liable in law accordingly.</p>
<p class="copyright">This first world edition published 2015</p>
<p class="copyright">in Great Britain and the USA by</p>
<p class="copyright">SEVERN HOUSE PUBLISHERS LTD of</p>
<p class="copyright">19 Cedar Road, Sutton, Surrey, England, SM2 5DA.</p>
<p class="copyright">Trade paperback edition first published 2015 in Great </p>
<p class="copyright-space-after">Britain and the USA by SEVERN HOUSE PUBLISHERS LTD.</p>
<p class="copyright">eBook edition first published in 2015 by Severn House Digital </p>
<p class="copyright-space-after">an imprint of Severn House Publishers Limited</p>
<p class="copyright-space-after">Copyright © 2015 by Marcia Talley.</p>
<p class="copyright-space-after">The right of Marcia Talley to be identified as the author of this work has been asserted in accordance with the Copyright, Designs &amp; Patents Act 1988.</p>
<p class="copyright-space-after">British Library Cataloguing in Publication Data</p>
<p class="copyright">Talley, Marcia Dutton, 1943- author.</p>
<p class="copyright">Daughter of ashes. – (The Hannah Ives mysteries series)</p>
<p class="copyright">1. Ives, Hannah (Fictitious character)–Fiction.</p>
<p class="copyright">2. Dwellings–Remodeling–Fiction. 3. Public records–</p>
<p class="copyright">Fiction. 4. Detective and mystery stories.</p>
<p class="copyright">I. Title II. Series</p>
<p class="copyright-space-after">813.6-dc23</p>
<p class="copyright">ISBN-13: 978-0-7278-8493-0 (cased)</p>
<p class="copyright">ISBN-13: 978-1-84751-600-8 (trade paper)</p>
<p class="copyright-space-after">ISBN-13: 978-1-78010-651-9 (e-book)</p>
<p class="copyright-space-after">Except where actual historical events and characters are being described for the storyline of this novel, all situations in this publication are fictitious and any resemblance to living persons is purely coincidental.</p>
<p class="copyright">This ebook produced by </p>
<p class="copyright">Palimpsest Book Production Limited, Falkirk, </p>
<p class="copyright">Stirlingshire, Scotland.</p>
<p class="copyright"></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106519_epub_cop.vue?8862a6da